/**
 * @generated SignedSource<<50424c38a4ed43af6c9dfa49f0e81251>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type categoryAllGetQuery$variables = {};
export type categoryAllGetQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"categoryPaginationFragment">;
};
export type categoryAllGetQuery = {
  response: categoryAllGetQuery$data;
  variables: categoryAllGetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "kind": "Literal",
    "name": "sortingOpt",
    "value": {}
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "categoryAllGetQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "categoryPaginationFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "categoryAllGetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "CategoryConnection",
        "kind": "LinkedField",
        "name": "getAllCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CategoryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Category",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": "getAllCategories(first:30,sortingOpt:{})"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "filters": [
          "sortingOpt"
        ],
        "handle": "connection",
        "key": "Edges_getAllCategories",
        "kind": "LinkedHandle",
        "name": "getAllCategories"
      }
    ]
  },
  "params": {
    "cacheID": "1c382dc90e04ea4a957d51aeeae05b55",
    "id": null,
    "metadata": {},
    "name": "categoryAllGetQuery",
    "operationKind": "query",
    "text": "query categoryAllGetQuery {\n  ...categoryPaginationFragment\n}\n\nfragment categoryPaginationFragment on Query {\n  getAllCategories(first: 30, sortingOpt: {}) {\n    edges {\n      node {\n        id\n        body\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "c17551a3cce625e93c9953c1904af5a9";

export default node;
